import React, { FC, useRef } from 'react'
import { CatalogColumn, SortState } from './types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { formatTimeZone } from 'src/utils/TimeZoneDateFormat'

interface TableHeaderCellProps {
  column: CatalogColumn
  sortState: SortState | null
  onOpenMenu: (column: CatalogColumn, anchorEl: HTMLElement) => void
  displayLabel?: string
  menuDisabled?: boolean
  hasActiveFilter?: boolean
}

export const TableHeaderCell: FC<TableHeaderCellProps> = ({
  column,
  sortState,
  onOpenMenu,
  displayLabel,
  menuDisabled = false,
  hasActiveFilter = false,
}) => {
  const cellRef = useRef<HTMLDivElement>(null)
  const menuButtonRef = useRef<HTMLButtonElement>(null)

  const isSorted = sortState?.field === column.field
  const sortDirection = isSorted ? sortState.direction : null

  const handleMenuClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    const anchorEl = menuButtonRef.current || cellRef.current
    if (anchorEl) {
      onOpenMenu(column, anchorEl)
    }
  }

  return (
    <div
      ref={cellRef}
      className="d-flex align-items-center justify-content-between w-100"
      style={{
        minHeight: '40px',
      }}
    >
      <div className="d-flex align-items-center gap-2 flex-fill">
        <span className="fw-bold text-dark" style={{whiteSpace: 'nowrap'}}>
          {displayLabel || column.label || column.field}
        </span>
        {(column.field === 'created_at' || column.field === 'updated_at') && (
          <OverlayTrigger placement='top' overlay={<Tooltip>{formatTimeZone()}</Tooltip>}>
            <span className='text-muted' style={{fontSize: '12px', cursor: 'help'}}>
              <i className='bi bi-info-circle'></i>
            </span>
          </OverlayTrigger>
        )}
        
        {/* Sort indicator */}
        {isSorted && (
          <i
            className={`bi ${
              sortDirection === 'asc'
                ? 'bi-sort-alpha-down'
                : 'bi-sort-alpha-down-alt'
            } text-primary`}
          ></i>
        )}
      </div>

      {!menuDisabled && (
        <button
          ref={menuButtonRef}
          className="btn btn-sm btn-icon p-1 position-relative"
          onClick={handleMenuClick}
          title="Column menu"
          style={{ 
            marginLeft: '8px',
            backgroundColor: 'transparent',
            border: 'none',
            color: hasActiveFilter ? '#0d6efd' : '#6c757d'
          }}
        >
          <i className="bi bi-three-dots-vertical"></i>
          {hasActiveFilter && (
            <span
              style={{
                position: 'absolute',
                top: 2,
                right: 2,
                width: 6,
                height: 6,
                borderRadius: '50%',
                backgroundColor: '#0d6efd',
              }}
            />
          )}
        </button>
      )}
    </div>
  )
}
